import { cleanClass } from '@shared/utils/cleanClass.js';
import IconV2 from '../v2/IconV2';
import { FiInfo } from '../react-icons/main';

const PageGroup = ({ children, title, info, className = '' }) => {
  return (
    <div className={cleanClass(`comp-page-group ${className}`)}>
      {title && (
        <div className="title-row">
          <div className={'title'}>{title}</div>
          {info && <IconV2 icon={FiInfo} size={12} className={'light-medium'} title={info} />}
        </div>
      )}
      {children}
    </div>
  );
};

export default PageGroup;
